<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">Shipping Method</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <jni-spinner *ngIf="showSmallLoader"></jni-spinner>
        </span>
      </span>

      <div class="col-12">
        <form>
          <div class="col-12 p-4">
            <div class="row">
              <p-pickList
                [source]="shippingMethodProductsList"
                [target]="shippingMethodProductsList"
                sourceHeader="Options Available in Shipping Method"
                targetHeader="Set Order of Shipping Method"
                [dragdrop]="true"
                [responsive]="true"
                [showSourceControls]="false"
                [showTargetControls]="false"
                [sourceStyle]="{ height: '350px' }"
                [targetStyle]="{ display: 'none' }"
                [moveAllToTargetProps]="{ styleClass: 'display: none' }">
                <ng-template let-opt pTemplate="item">
                  <div
                    class="d-flex justify-content-between align-items-center col-12">
                    <p class="p-pickListDesc mb-0 pb-0">
                      {{ opt.modeDescriptionD365 }}
                    </p>
                    <span class="col-auto">{{ getIndexById(opt.id) }}</span>
                  </div>
                </ng-template>
              </p-pickList>
            </div>
          </div>

          <div class="d-flex p-4 has-sticky justify-content-end gap-2 pt-0">
            <p-button
              label="Cancel"
              routerLink="/dashboard"
              variant="outlined"
              severity="secondary" />

            <p-button
              label="Save"
              [disabled]="!shippingMethodProductsList?.length"
              (click)="shippingMethodOrderUpdate()" />
          </div>
        </form>
      </div>
    </p-card>
  </div>
</div>
